import { render, staticRenderFns } from "./ServiceCard.vue?vue&type=template&id=6ecc2cbe&scoped=true&"
import script from "./ServiceCard.vue?vue&type=script&lang=js&"
export * from "./ServiceCard.vue?vue&type=script&lang=js&"
import style0 from "./ServiceCard.vue?vue&type=style&index=0&id=6ecc2cbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecc2cbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ecc2cbe')) {
      api.createRecord('6ecc2cbe', component.options)
    } else {
      api.reload('6ecc2cbe', component.options)
    }
    module.hot.accept("./ServiceCard.vue?vue&type=template&id=6ecc2cbe&scoped=true&", function () {
      api.rerender('6ecc2cbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/services/ServiceCard.vue"
export default component.exports